var constants = require('./constants');
var filekeyHelpers = require('./filekey-helpers');
var awsConstants = constants.awsConstants;
var semver = require('semver');

var publish = require('./publish-handler');
var versionUtils = require('./version-utils')

if (!global.test) {
    var auth = require('./auth-handler');
    var authHandler = auth.authHandler;
    var swal = require('bootstrap-sweetalert');
    swal.setDefaults({ animation: false });
    var router = require('./router').router;
}

var publishBuildFormModel = {
    init: function () {
        this.selectedReleaseNotes = '';
        this.isProcessing = false;
        if (localStorage.getItem('builds')) {
            this.builds = this.getBuilds();
        } else {
            localStorage.setItem('builds', JSON.stringify({}));
        }

        var models = this.getPublishedFirmwareModels();
        if (models && models.length) {
            this.isExistingFirmwareModel = true;
        }

    },
    getPublishedFirmwareModels: function () {
        var modelsItem = localStorage.getItem('models');
        if (modelsItem) {
            var modelsObjArray = JSON.parse(modelsItem);
            return modelsObjArray.map(modelObj => modelObj.model);
        } else {
            return [];
        }
    },
    getBuilds: function () {
        return JSON.parse(localStorage.getItem('builds'));
    },
    updateBuilds: function (builds) {
        localStorage.setItem('builds', JSON.stringify(builds));
    },
    getUsername: function () {
        return localStorage.getItem('username');
    },
    getResource2List: function () {
        return JSON.parse(localStorage.getItem('resource2-list'));
    },
    updateResource2List: function (list) {
        localStorage.setItem('resource2-list', JSON.stringify(list));
    },
    getMetadataForFirmware: function (firmwareKey) {
        var list = this.getList();
        return list.find(function (firmware) {
            if (firmware.firmware) {
                return firmware.firmware === firmwareKey;
            }
        });
    }
};

var publishBuildFormController = {
    init: function () {
        var self = this;
        publishBuildFormModel.init();
        publishBuildFormView.init();

        if (!self.s3listenerInited) {
            self.s3listenerInited = true;
            document.addEventListener('s3Ready', function () {
                if (window.location.hash !== '#/publish-build') {
                    return;
                }
                var promises = [
                    self.getBuilds(),
                    self.getResource2Files()
                ];

                return Promise.all(promises)
                    .then(function (res) {
                        var builds = res[0];
                        var resource2List = res[1];
                        publishBuildFormModel.updateResource2List(resource2List);
                        publishBuildFormModel.updateBuilds(builds);
                        publishBuildFormView.renderModelSelect();
                        publishBuildFormView.renderBuildSelect();
                        publishBuildFormView.renderResource2Select();
                    })
                    .catch(function (error) {
                        swal('Build List Update Error', error, 'error');
                    });
            });
        }
    },
    getBuilds: function () {
        var refreshTokenIfNeededPromise;
        if (window.session.isValid()) {
            refreshTokenIfNeededPromise = Promise.resolve(null);
        } else {
            refreshTokenIfNeededPromise = authHandler.init();
        }
        return refreshTokenIfNeededPromise
            .then(function (res) {
                return window.s3.listObjects({
                    Bucket: awsConstants.buckets.std,
                    Prefix: 'build'
                }).promise();
            })
            .then(function (list) {
                var builds = {};
                list.Contents
                    .filter(function (item) {
                        return item.Size > 0;
                    }).forEach(function (item) {
                        var key = item.Key;
                        var buildName = key.split('/')[1];
                        var isBinFile = key.substring(key.length - 4) === '.bin';
                        if (!builds[buildName]) {
                            builds[buildName] = {};
                        }
                        if (isBinFile) {
                            builds[buildName].buildKey = key;
                        } else {
                            builds[buildName].resource1Key = key;
                        }
                    });
                return builds;
            });
    },
    getResource2Files: function () {
        var self = this;
        return this.getResource2FileS3Keys()
            .then(function (keys) {
                return self.getResource2FilesMetadata(keys);
            });
    },
    getResource2FileS3Keys: function () {
        return window.s3.listObjects({
            Bucket: awsConstants.buckets.std,
            Prefix: 'resource2'
        }).promise()
            .then(function (list) {
                return list.Contents
                    .filter(function (item) {
                        return item.Size > 0;
                    })
                    .map(function (item) {
                        return item.Key;
                    });
            });
    },
    getResource2FilesMetadata: function (resource2FileS3Keys) {
        var promises = [];
        if (resource2FileS3Keys && resource2FileS3Keys.length) {
            resource2FileS3Keys.forEach(function (key) {
                promises.push(window.s3.headObject({
                    Bucket: awsConstants.buckets.std,
                    Key: key
                }).promise());
            });
        }
        return Promise.all(promises)
            .then(function (res) {
                return res.map(function (item) {
                    return item.Metadata;
                });
            });
    },
    toggleFirmwareModelSelect: function () {
        if (publishBuildFormModel.isExistingFirmwareModel) {
            publishBuildFormView.showFirmwareInput();
            publishBuildFormModel.isExistingFirmwareModel = false;
        } else {
            publishBuildFormView.showFirmwareSelect();
            publishBuildFormModel.isExistingFirmwareModel = true;
        }
    },
    validateInputs: function (firmware) {
        var errorMessages = [];

        if (!firmware.firmware || !firmware.firmware.length) {
            errorMessages.push('Build is required');
        }
        if (!firmware.model || !firmware.model.length) {
            errorMessages.push('Model is required.');
        }

        // if (firmware.resource2Version == "") {
        //     errorMessages.push('Resource 2 version is required')    
        // }        

        // if (firmware.resource2Versions.length == 0) {
        //     errorMessages.push('Server error found no resource 2 locales for this version')    
        // }

        if (!firmware.version || !firmware.version.length) {
            errorMessages.push('Firmware Version is required.');
        } else if (!this.checkVersionFormat(firmware.version)) {
            errorMessages.push('Invalid version format for Firmware file. The correct version format is x.x.x.');
        }

        if (!firmware.releaseNotes || !firmware.releaseNotes.length) {
            errorMessages.push('Release notes file is required.');
        }
        return errorMessages;
    },
    metadataWithoutReleaseNotes: function (metadata) {
        var firmwareWithoutReleaseNotes = Object.assign({}, metadata);
        delete firmwareWithoutReleaseNotes.releaseNotes;
        return firmwareWithoutReleaseNotes;
    },
    checkVersionFormat: function (version) {
        return semver.valid(version);
    },
    publishFile: function (firmware) {
        var self = this;
        var refreshTokenIfNeededPromise;
        publishBuildFormModel.isProcessing = true;
        publishBuildFormView.toggleSpinnerState('show');
        if (window.session.isValid()) {
            refreshTokenIfNeededPromise = Promise.resolve(null);
        } else {
            refreshTokenIfNeededPromise = authHandler.init();
        }
        return refreshTokenIfNeededPromise
            .then(function () {
                return publish(awsConstants.buckets.std, firmware);
            })
            .then(function () {
                console.log("IS EXISTING MODEL" + publishBuildFormModel.isExistingFirmwareModel)
                if (!publishBuildFormModel.isExistingFirmwareModel) {
                    return self.createTopicIfDoesNotExist(firmware.model);
                } else {
                    return Promise.resolve(null)
                }
            })
            .then(function () {
                publishBuildFormModel.isProcessing = false;
                publishBuildFormView.toggleSpinnerState('hide');
                // TODO: need to trigger modelSelect change handler to restore this functionality
                //localStorage.setItem('filtered-model', firmware.model);
                //router.navigate('/dashboard');
                swal('Publish Success', 'Firmware successfully published', 'success');
            })
            .catch(function (error) {
                publishBuildFormModel.isProcessing = false;
                publishBuildFormView.toggleSpinnerState('hide');
                if (error !== 'authexpired' && error !== 'cancelled') {
                    swal('Publish Error', error, 'error');
                }
            });
    },
    createTopicIfDoesNotExist: function (model) {
        return window.sns.listTopics().promise()
            .then(function (result) {
                const topics = result.Topics;
                var topicArns = topics.map(function (topic) { return topic.TopicArn; });
                var topicArnIdx = topicArns.findIndex(function (topicArn) {
                    return topicArn.split(':')[5] === model;
                });

                if (topicArnIdx === -1) {
                    return window.sns.createTopic({ Name: model }).promise()
                        .then(function (data) {
                            console.log('created new topic');
                        })
                        .catch(function (data) {
                            reject('Publish succeeded but failed to create SNS Topic for push notifications.');
                        })
                } else {
                    return Promise.resolve(null)
                }
            })
    },
    resourceFile1Exists: function (firmwareName) {
        var resource1Key = filekeyHelpers.generateResourceFile1Key(firmwareName);
        var params = {
            Bucket: awsConstants.buckets.std,
            Key: resource1Key
        };
        return window.s3.headObject(params).promise()
            .catch(function (error) {
                console.log(error.code);
                if (error.code === 'NotFound') {
                    return false;
                } else {
                    throw error;
                }
            });
    },
    getResource2UniqueVersions: function () {
        var resource2Files = publishBuildFormModel.getResource2List();
        return versionUtils.sortByVersion(resource2Files, true).filter(function (item, pos, ary) {
            return !pos || item.version != ary[pos - 1].version;
        })
    },
    getResource2ObjectsForVersion: function(version) {
        var resource2Files = publishBuildFormModel.getResource2List();
        return resource2Files.filter(function (item) {
            return item.version == version
        })
    },
    getLocalesForVersion: function (version) {
        var resource2Files = publishBuildFormModel.getResource2List();
        var locales = resource2Files.filter(function (item) {
            return item.version == version
        }).map(function (item) {
            console.log(item)
            return item.locale
        })
        return this.unique(locales)
    },
    unique: function (a) {
        var seen = {};
        return a.filter(function(item) {
            return seen.hasOwnProperty(item) ? false : (seen[item] = true);
        });
    }
};

var publishBuildFormView = {
    init: function () {
        this.publishFirmwareFormEl = document.querySelector('#publish-build-form');
        this.firmwareFileModelEl = document.querySelector('#firmware-file-model');
        this.firmwareFileVersionEl = document.querySelector('#firmware-file-version');
        this.firmwareReleaseNotesEl = document.querySelector('#firmware-release-notes');
        this.publishFirmwareButtonTextEl = document.querySelector('#publish-build-button-text');
        this.publishFirmwareButtonSpinnerEl = document.querySelector('#publish-build-button-spinner');
        this.buildSelectEl = document.querySelector('#build-select');
        this.firmwareFileModelSelectEl = document.querySelector('#firmware-file-model-select');
        this.firmwareFileModelInputEl = document.querySelector('#firmware-file-model-input');
        this.firmwareFileModelButtonEl = document.querySelector('#firmware-file-model-button');
        this.publishFirmwareButtonTextEl = document.querySelector('#publish-build-button-text');
        this.publishFirmwareButtonSpinnerEl = document.querySelector('#publish-build-button-spinner');
        this.resource2SelectEl = document.querySelector('#firmware-resource2')
        this.releaseNotesFileEl = document.querySelector('#release-notes-file');
        this.supportedLocalesDivEl = document.querySelector('#supported-locales-div');
        this.supportedLocalesContainerDivEl = document.querySelector('#supported-locales-container-div')


        this.initSubmitHandler();
        this.initReleaseNotesDisplayHandler();
        this.initFirmwareSelectToggleHandler();
        if (publishBuildFormModel.getPublishedFirmwareModels().length) {
            this.showFirmwareSelect();
        } else {
            this.showFirmwareInput();
        }
        this.renderBuildSelect();
        this.renderModelSelect();
        this.initResource2SelectHandler();
    },
    initFirmwareSelectToggleHandler: function () {
        this.firmwareFileModelButtonEl.addEventListener('click', function (e) {
            publishBuildFormController.toggleFirmwareModelSelect();
        });
    },
    initReleaseNotesDisplayHandler: function () {
        var self = this;
        this.releaseNotesFileEl.onchange = function (e) {
            var reader = new FileReader();
            reader.onload = function () {
                publishBuildFormModel.selectedReleaseNotes = reader.result;
                self.updateReleaseNotes('release-notes-file-div', reader.result);
            };
            reader.readAsText(self.releaseNotesFileEl.files[0]);
        };
    },
    updateReleaseNotes: function (divId, fileName) {
        var selectedFileText = document.querySelector('#' + divId + ' .selected-file-text');
        selectedFileText.innerHTML = fileName;
        selectedFileText.style = 'margin-bottom:15px';
        document.querySelector('#' + divId + ' .select-file-button-text').innerHTML = 'Change File';
    },
    initSubmitHandler: function (e) {
        var self = this;
        this.publishFirmwareFormEl.addEventListener('submit', function (e) {
            e.preventDefault();
            var selectedBuildKey = self.buildSelectEl.options[self.buildSelectEl.selectedIndex].value;
            var selectedBuild = publishBuildFormModel.getBuilds()[selectedBuildKey] || {};
            var selectedResource2Version = self.resource2SelectEl.value
            var inputs = {
                releaseNotes: publishBuildFormModel.selectedReleaseNotes,
                version: self.firmwareFileVersionEl.value,
                firmware: selectedBuild.buildKey,
                firmware_name: selectedBuildKey,
                resource1: selectedBuild.resource1Key,
                username: publishBuildFormModel.getUsername()
            };
            if (selectedResource2Version && selectedResource2Version != '') {
                inputs.resource2Versions = publishBuildFormController.getResource2ObjectsForVersion(selectedResource2Version)
                console.log('resource 2 locale file metadata for this version')
                console.log(inputs.resource2Versions)
            }
            if (publishBuildFormModel.isExistingFirmwareModel) {
                inputs.model = self.firmwareFileModelSelectEl.options[self.firmwareFileModelSelectEl.selectedIndex].value;
            } else {
                inputs.model = self.firmwareFileModelInputEl.value;
            }
            const errorMessages = publishBuildFormController.validateInputs(inputs);
            if (errorMessages.length) {
                swal('Validation Errors', errorMessages.join('\n'), 'error');
                return;
            }
        
            publishBuildFormController.publishFile(inputs);
        });
    },
    initResource2SelectHandler: function () {
        var self = this;
        this.resource2SelectEl.onchange = function () {
            var version = self.resource2SelectEl.value;
            console.log('version ' + version);
            if (version != "") {
                var locales = publishBuildFormController.getLocalesForVersion(version);
                console.log('locales ' + locales);
                self.showLocales(locales);
            } else {
                self.hideLocales(locales);
            }
        }
    },
    showLocales: function (locales) {
        if (locales.constructor === Array && locales.length > 0) {
            this.supportedLocalesDivEl.innerHTML = locales.join(', ')
            this.supportedLocalesContainerDivEl.style = '';
        }
    },
    hideLocales: function () {
        this.supportedLocalesContainerDivEl.style.display = 'none';
        this.supportedLocalesDivEl.innerHTML = '';
    },
    showFirmwareSelect: function () {
        this.firmwareFileModelSelectEl.style.display = 'inline-block';
        this.firmwareFileModelSelectEl.style.width = '25em';
        this.firmwareFileModelInputEl.style.display = 'none';
        this.firmwareFileModelButtonEl.innerHTML = 'New Model';
    },
    showFirmwareInput: function () {
        this.firmwareFileModelSelectEl.style.display = 'none';
        this.firmwareFileModelInputEl.style.display = 'inline-block';
        this.firmwareFileModelButtonEl.innerHTML = 'Existing Model';
    },
    renderModelSelect: function () {
        var self = this;
        var models = publishBuildFormModel.getPublishedFirmwareModels();
        this.firmwareFileModelSelectEl.options.length = 0;
        this.firmwareFileModelSelectEl.options[0] = new Option('', '', false, false);
        models.forEach(function (model, index) {
            self.firmwareFileModelSelectEl.options[index + 1] = new Option(model, model, false, false);
        });
    },
    renderBuildSelect: function () {
        var self = this;
        var builds = publishBuildFormModel.getBuilds();
        this.buildSelectEl.options.length = 0;
        this.buildSelectEl.options[0] = new Option('', '', false, false);
        Object.keys(builds).forEach(function (key, index) {
            self.buildSelectEl.options[index + 1] = new Option(key, key, false, false);
        });
    },
    renderResource2Select: function () {
        var self = this;
        var versions = publishBuildFormController.getResource2UniqueVersions()
        this.resource2SelectEl.options.length = 0;
        this.resource2SelectEl.options[0] = new Option('', '', false, false);
        Object.keys(versions).forEach(function (key, index) {
            self.resource2SelectEl.options[index + 1] = new Option(versions[key].version, versions[key].version, false, false);
        });
    },
    toggleSpinnerState: function (state) {
        if (state === 'show') {
            this.publishFirmwareButtonTextEl.innerHTML = 'Publishing';
            this.publishFirmwareButtonSpinnerEl.style = 'margin-right:5px;';
        } else {
            this.publishFirmwareButtonTextEl.innerHTML = 'Publish';
            this.publishFirmwareButtonSpinnerEl.style = 'display:none;';
        }
    }
};

module.exports = {
    publishBuildFormController: publishBuildFormController,
    publishBuildFormModel: publishBuildFormModel
};
